<template>
  <pagefra>
    <div class="thirdParty fullscreen container">
      <panel type="toolbar">
        <div class="toolbar">
          <el-form :inline="true" v-model="form" class="toolbar-form">
            <el-form-item :label="$l('系统账号')">
              <el-input
                v-model="form.username"
                maxlength="30"
                :placeholder="$l('系统账号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('第三方账号')">
              <el-input
                v-model="form.thirdUsername"
                maxlength="30"
                :placeholder="$l('第三方账号')"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$l('系统代码')">
              <el-input
                v-model="form.systemCode"
                maxlength="50"
                :placeholder="$l('系统代码')"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              @click="showAdd()"
              v-show="hasPermission('新增')"
              >{{ $l("新增") }}
            </el-button>
            <el-button
              icon="el-icon-delete"
              round
              @click="deleteThirdPartyUser"
              v-show="hasPermission('删除')"
              >{{ $l("删除") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="singleTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
            @selection-change="selectChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              :label="$l('序号')"
              min-width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              property="systemCode"
              :label="$l('系统代码')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="username"
              :label="$l('系统账号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="thirdUsername"
              :label="$l('第三方账号')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="thirdName"
              :label="$l('第三方应用名称')"
              min-width="150"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="creator"
              :label="$l('创建者')"
              min-width="120"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="createDate"
              :label="$l('创建时间')"
              min-width="180"
              header-align="center"
              align="center"
            >
            </el-table-column>
            <el-table-column
              :label="$l('编辑')"
              min-width="80"
              header-align="center"
              align="center"
              fixed="right"
              v-if="hasPermission('编辑')"
            >
              <template slot-scope="scope">
                <el-button
                  @click.native.prevent="showEdit(scope.row)"
                  type="primary"
                  clear
                  icon="el-icon-edit-outline"
                >
                </el-button>
                <!-- <el-button type="primary" clear icon="el-icon-delete">
              </el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          :current-page="pageConfig.currentPage"
          :page-sizes="pageConfig.pageSizes"
          :page-size="pageConfig.pageSize"
          :total="pageConfig.total"
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentPageChange"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </panel>

      <el-dialog
        :title="$l(editDialogTitle)"
        :visible.sync="editDialogVisible"
        @closed="closeEditDialog"
        width="640px"
      >
        <el-form
          ref="editForm"
          :model="editForm"
          :rules="rules"
          label-width="140px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('系统代码')" prop="systemCode">
            <el-input v-model="editForm.systemCode"></el-input>
          </el-form-item>
          <el-form-item :label="$l('系统账号')" prop="username">
            <el-input v-model="editForm.username"></el-input>
          </el-form-item>
          <el-form-item :label="$l('第三方账号')" prop="thirdUsername">
            <el-input v-model="editForm.thirdUsername"></el-input>
          </el-form-item>
          <el-form-item :label="$l('第三方应用名称')" prop="thirdName">
            <el-input v-model="editForm.thirdName"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="editDialogVisible = false"
            >{{ $l("取消") }}
          </el-button>
          <el-button round type="primary" @click="submit"
            >{{ $l("确定") }}
          </el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";

export default {
  name: "thirdParty",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    var validateUserName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入系统账号")));
      } else {
        callback();
      }
    };
    var validateThirdUserName = (rule, value, callback) => {
      if (value.trim() == "") {
        callback(new Error(this.$l("请输入第三方账号")));
      } else {
        callback();
      }
    };
    return {
      form: {
        username: "",
        thirdUsername: "",
        systemCode: "",
      },
      editDialogVisible: false,
      editDialogTitle: "",
      editForm: {
        id: null,
        username: "",
        thirdUsername: "",
        thirdName: "",
        systemCode: "",
      },
      rules: {
        systemCode: [
          {
            max: 50,
            message: this.$l("长度不能超过 50 个字符"),
            trigger: "blur",
          },
        ],
        username: [
          {
            required: true,
            message: this.$l("请输入系统账号"),
            trigger: "blur",
          },
          {
            max: 30,
            message: this.$l("长度不能超过 30 个字符"),
            trigger: "blur",
          },
          { validator: validateUserName, trigger: "blur" },
        ],
        thirdUsername: [
          {
            required: true,
            message: this.$l("请输入第三方账号"),
            trigger: "blur",
          },
          {
            max: 30,
            message: this.$l("长度不能超过 30 个字符"),
            trigger: "blur",
          },
          { validator: validateThirdUserName, trigger: "blur" },
        ],
        thirdName: [
          {
            max: 100,
            message: this.$l("长度不能超过 100 个字符"),
            trigger: "blur",
          },
        ],
      },
      tableData: null,
      loading: false,
      url: "",
    };
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    showAdd() {
      this.editDialogTitle = "新建";
      this.editDialogVisible = true;
      for (const key in this.editForm) {
        this.editForm[key] = null;
      }
    },
    showEdit(row) {
      this.editDialogTitle = "编辑";
      this.editDialogVisible = true;
      this.$http
        .get(this.$apiConfig.get_third_party_user_url + row.id)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            for (let key in this.editForm) {
              this.editForm[key] = result.data[key];
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    search() {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.tableData = [];
      this.loading = true;
      this.$http
        .get(this.$apiConfig.search_third_party_user_url, {
          params: this.form,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.pageConfig.total = result.data.total;
            this.tableData = result.data.result;
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$http
            .post(this.$apiConfig.save_third_party_user_url, this.editForm)
            .then((response) => {
              let result = response.data;
              this.message(result.code, result.msg);
              if (result.code == 0) {
                this.editDialogVisible = false;
                this.search();
              }
            })
            .catch((error) => {
              this.errorMessage(0);
              this.$sentry.captureException(error);
            });
        } else {
          return false;
        }
      });
    },
    selectChange(selection) {
      this.selectedList = selection;
    },
    deleteThirdPartyUser() {
      let len = this.selectedList.length;
      if (len == 0) {
        this.message(1, "请选择要删除的数据");
        return;
      }
      this.confirmAlert(() => {
        let idList = [];
        for (let i = 0; i < len; i++) {
          idList.push(this.selectedList[i].id);
        }
        let formData = new FormData();
        formData.append("idList", idList);
        this.$http
          .post(this.$apiConfig.delete_third_party_user_url, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.search();
            }
          })
          .catch((error) => {
            this.errorMessage(3);
            this.$sentry.captureException(error);
          });
      });
    },
    closeEditDialog() {},
  },
};
</script>
<style scoped lang="scss">
.dialog-form {
  .el-input {
    width: 400px;
  }
  .el-textarea {
    width: 400px;
  }
  .el-select {
    width: 400px;
  }
  .el-cascader {
    width: 400px;
  }
}
.inputfra {
  width: 400px;
  height: 300px;
  max-height: 50vh;
  .el-checkbox-group {
    margin-left: 10px;
    line-height: 2;
    .el-checkbox {
      display: block;
    }
  }
}
</style>
